/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Error_Incident_CodeInputs */

const vi_error_incident_code = /** @type {(inputs: Error_Incident_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã sự cố: ${i?.code}`)
};

/**

* @param {Error_Incident_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_incident_code = /** @type {((inputs: Error_Incident_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Incident_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_incident_code(inputs)
});